module.exports = __webpack_public_path__ + "static/assets/80c7503180eff7feac884ffc8dc49dcf.png";